"use client";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import Image from "next/image";
import ArrowIcon from "../../public/arrowRight.svg";

export function StickyButton({ label }) {
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const pageHeight = document.documentElement.scrollHeight;

      const distanceToBottom = pageHeight - (scrollY + windowHeight);
      const shouldShow = scrollY > 300 && distanceToBottom > 1000;
      setVisible(shouldShow);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div
      style={{
        position: "sticky",
        bottom: "16px",
        left: 0,
        right: 0,
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        pointerEvents: "none",
      }}
    >
      <button
        style={{
          pointerEvents: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          backgroundColor: "#FFD600",
          color: "#000",
          padding: "14px 24px",
          fontSize: "16px",
          fontWeight: 600,
          borderRadius: "9999px",
          border: "none",
          cursor: "pointer",
          width: "90vw",
          maxWidth: "400px",
          height: "56px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          transition: "transform 0.2s ease",
          transform: hovered ? "scale(1.05)" : "scale(1)",
          cursor: "pointer",
        }}
        onClick={() => router.push("/checkout")}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <span style={{ fontFamily: "Poppins", fontWeight: "bold" }}>
          {label || "Je me lance !"}
        </span>
        <span style={{ display: "flex", alignItems: "center", fontWeight: "bold" }}>
          <Image src={ArrowIcon} alt="arrow" width={20} height={20} />
        </span>
      </button>
    </div>
  );
}
